import { atom } from "recoil";

export const calendarState = atom({
  key: "calendarState",
  default: {
    calendar: {},
    events: [],
  },
});
